<template>
  <div
    class="utility bg-tertiary"
    v-bind:class="{ 'utility--active': isActive }"
  >
    <div class="bg-tertiary">
      <slot></slot>
    </div>
    <div class="utility__overlay"></div>
  </div>
</template>

<script>
export default {
  props: {
    isActive: Boolean
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/modules/utility.scss";
</style>
